export enum NewPaymentErrorType {
    VendorValidationFailed = 'Vendor validation failed',
    CardValidationFailed = 'Card Validation Failed',
    BankValidationFailed = 'Bank validation failed',
    FlowCanceled = 'Flow canceled',
  }


// WEBPACK FOOTER //
// ./src/model/types/newPayment-error-type.ts